export const SAIN_CITATION_ATTRIBUTE = 'data-sain-citation' as const;
export const SAIN_CITATION_SELECTOR = '[data-sain-citation]' as const;
